module.exports = __webpack_public_path__ + "img/regalo.eb0d8100.png";